import React from "react";
import "./SchoolClasses.scss";
import DashboardTopBar from "../../../components/PortalComponents/DashboardTopBar/DashboardTopBar";
import DashboardNavbar from "../../../components/PortalComponents/DashboardNavbar/DashboardNavbar";
import { GoHomeFill } from "react-icons/go";
import { IoIosArrowForward } from "react-icons/io";

const SchoolClasses = () => {
  const preSchoolClassList = [
    "Creche",
    "Upper creche",
    "Nursery 1",
    "Nursery 2",
    "Kindergarten 1",
    "Kindergarten 2",
  ];
  const gradeSchoolClassList = [
    "Grade 1",
    "Grade 2",
    "Grade 3",
    "Grade 4",
    "Grade 5",
    "Grade 6",
  ];
  return (
    <div>
      <DashboardTopBar />
      <DashboardNavbar />
      <div id="school-classes" className="portal-page">
        <div className="admin-dashboard-title">
          <div className="admin-dashboard-navigation">
            <GoHomeFill /> <IoIosArrowForward />{" "}
            <span className="section">Dashboard</span> <IoIosArrowForward />{" "}
            <span className="section">Classes</span>
          </div>
        </div>
        <div className="section-list classes-list-section">
          <div className="table-section-header">Classes</div>
          <div className="classes-list">
            <div className="class-level">
              <div className="class-level-title">
                <div className="class-level-title-name">Pre-School</div>
              </div>
              <div className="class-level-body">
                {preSchoolClassList.map((preSchoolClass, index) => (
                  <div className="school-class">{preSchoolClass}</div>
                ))}
              </div>
            </div>
            <div className="class-level">
              <div className="class-level-title">
                <div className="class-level-title-name">Grade School</div>
              </div>
              <div className="class-level-body">
                {gradeSchoolClassList.map((gradeSchoolClass, index) => (
                  <div className="school-class" key={index}>
                    {gradeSchoolClass}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolClasses;
